// extracted by mini-css-extract-plugin
export var typingIndicator = "_si-0";